import { GridInputs } from "../../../../../components/Functional";

const getSaleInputs = ({ artists, invoiceAnalysisEvents, artworkCategories } = {}) => ({
  className: "grid grid-rows-2 gap-4",
  inputs: [
    {
      className: "grid grid-cols-1 gap-4 lg:grid-cols-4",
      inputs: [
        {
          hasOperator: true,
          isMulti: true,
          label: "Purchased Artist",
          name: "_invoice._item._instance._edition._artwork._artist.id",
          options: artists?.map(artist => ({
            label: artist.name,
            value: artist.id,
          })),
          type: "multi-select",
        },
        {
          hasOperator: true,
          isMulti: true,
          label: "Category",
          name: "_invoice._item._instance._edition._artwork.categoryId",
          options: artworkCategories?.map(item => ({
            label: item.name,
            value: item.id,
          })),
          type: "multi-select",
        },
        {
          label: "Value Start",
          name: "_invoice._item.price.value.from",
          operator: "gte",
          type: "number",
        },
        {
          label: "Value Ends",
          name: "_invoice._item.price.value.to",
          operator: "lte",
          type: "number",
        },
        {
          label: "Invoice Date Start",
          name: "_invoice.date.value.from",
          type: "date",
        },
        {
          label: "Invoice Date End",
          name: "_invoice.date.value.to",
          type: "date",
        },
        {
          label: "Total Spend Start",
          name: "totalSpend.value.from",
          type: "number",
        },
        {
          label: "Total Spend End",
          name: "totalSpend.value.to",
          type: "number",
        },
        {
          label: "Unit",
          name: "units",
          type: "number",
        },
        {
          hasOperator: true,
          isMulti: true,
          label: "Analysis",
          name: "_invoice.analysisId",
          options: invoiceAnalysisEvents?.map(item => ({
            label: item.description,
            value: item.id,
          })),
          type: "multi-select",
        },
      ],
    },
  ],
});

const Sales = props => {
  const { artists, artworkCategories, formik, invoiceAnalysisEvents } = props || {};

  const inputs = getSaleInputs({ artists, invoiceAnalysisEvents, artworkCategories });

  return <GridInputs formik={formik} {...inputs} />;
};

export default Sales;
export { getSaleInputs };
